import { Navigate, Outlet } from "react-router-dom";


const ProtectedRouteLogin = () => {



    let token = false;

    const loginStatus = localStorage.getItem("currentUserLoginStatus")

    if (loginStatus) {

        if (JSON.parse(loginStatus)) {

            token = true
        }
    }

    return token ? <Outlet /> : <Navigate to="/admin_login" />;




};

export default ProtectedRouteLogin;
